import { render } from "./upload-failed-overview.vue?vue&type=template&id=0233cbaa&ts=true"
import script from "./upload-failed-overview.ts?vue&type=script&lang=ts&external"
export * from "./upload-failed-overview.ts?vue&type=script&lang=ts&external"

import "./upload-failed-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__